import { Box, Stack } from "@mui/material"
import { BigNumber } from "ethers"
import { formatUnits } from "ethers/lib/utils"
import React, { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import Button from "src/components/Button"
import Text from "src/components/Text"
import { FER } from "src/constants"
import { BoostPoolInfo } from "src/constants/boostPools"
import { useIsMobile } from "src/hooks/useIsMobile"
import { formatLockPeriod } from "src/pages/Stake/helpers"
import { formatNumber } from "src/utils/parseStringToBigNumber"

interface Props extends BoostPoolInfo {
  accruedFer: BigNumber
}

const VaultRow = ({ lockPeriod, imgSrc, accruedFer, pid }: Props) => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  const goToDeposit = useCallback(() => {
    navigate(`/stake/vault?pid=${pid}`)
  }, [navigate, pid])

  return (
    <Box mt={3} pr={2}>
      <Box
        display={isMobile ? "block" : "flex"}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" alignItems="center">
          <img src={imgSrc} height={24} />
          <Text bold ml={1}>
            {formatLockPeriod(lockPeriod)}
          </Text>
        </Stack>
        <Box display={isMobile ? "block" : "flex"} alignItems="center">
          <Box mr={isMobile ? 0 : 3} mt={isMobile ? 1 : 0}>
            {accruedFer.isZero()
              ? "-"
              : `${FER.symbol} ${formatNumber(
                  formatUnits(accruedFer, FER.decimals),
                  2,
                  6,
                )}`}
          </Box>
          <Box width={isMobile ? "auto" : "103px"}>
            <Button
              onClick={goToDeposit}
              size="small"
              mt={isMobile ? 2 : 0}
              kind="outline"
              width="100%"
            >
              Deposit
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default VaultRow
